module.exports = (__webpack_require__(2))("./template/css/app.css");


//////////////////
// WEBPACK FOOTER
// delegated ./template/css/app.css from dll-reference base
// module id = 143
// module chunks = 22